import React from 'react'

export default function ParentsAttendance({ ViewDetail, parentsAttendance }) {
    return (
        <div className="row">
            <div className="col-4">
                <button className="btn text-capitalize d-block" type="button"
                    onClick={() => ViewDetail(parentsAttendance?.class)} >
                    Classes
                </button>
                <button className="btn text-capitalize d-block" type="button"
                    onClick={() => ViewDetail(parentsAttendance?.workshop)} >
                    Workshops
                </button>
                <button className="btn text-capitalize d-block" type="button"
                    onClick={() => ViewDetail(parentsAttendance?.appointment)}
                >  Appointments
                </button>
                <button type="button" data-toggle="modal" data-target="#viewAttandance"
                    id="btn_view" className="btn text-capitalize w-100 mt-3" data-backdrop="static"
                    data-keyboard="false" style={{ display: "none" }}> </button>

            </div>
            <div className="col-8">
                <p>
                    Summary (in last 30 days):
                    {parentsAttendance?.class.current_month}
                </p>
                <p>
                    Summary (in last 30 days):
                    {parentsAttendance?.workshop.current_month}
                </p>
                <p>
                    Summary (in last 30 days):
                    {parentsAttendance?.appointment.current_month}
                </p>
            </div>
        </div >
    )
}
